import { useEffect, useState } from "react";
import { autoCompleteProps } from "./MemberAutoComplete";
import { OptionTypeBase } from "react-select/src/types";
import { getCribLookupsExact, getCribLookupsTypeahead } from "../../../adapters";
import { RequiredIndicator } from "../../../features/registeredListing/RegisteredListingForm";
import AsyncSelect from "react-select/async";

const LocationAutoComplete = ({handleChange, handleBlur, errors, values, touched, setFieldValue, n, className}: autoCompleteProps) => {
    const [input, setInput] = useState<OptionTypeBase | null>(null);
    const disabled = false;
    const inputClass = touched[n.id] && errors[n.id] ? "input-registered-invalid" : (n.required ? "input-registered-required" : "input-registered") + (disabled ? " text-gray-50" : "");
    let groupId: number;

    const onChange = (e: any) => {
        setInput(e);
        if (e) {
            setFieldValue(n.id, e.value);
        }
    }

    switch (n.id) {
        case 'city':
            groupId = 8;
            break;
        default:
        case 'countyOrParish':
            groupId = 3;
            break;
    }

	useEffect(() => {
		if (groupId && values[n.id]) {
            const isLongValue = values[n.id].includes("-longValue");
            const searchTerm = isLongValue ? values[n.id].replace("-longValue", "") : values[n.id];
            
			getCribLookupsExact(groupId, searchTerm, isLongValue).then((response) => {
                const foundValue = response.data;
                if (foundValue && foundValue?.shortValue) {
                    setInput({
                        label: foundValue.longValue,
                        value: foundValue.shortValue,
                    });
                    setFieldValue(n.id, foundValue.shortValue);
                }
			}).catch((error) => {
                console.error("Crib lookup exact error:", error)
            });
		}
	}, [groupId, values[n.id]]);

	const loadOptions = (
		inputText: string,
		callback: (options: OptionTypeBase[]) => void
	): void => {
		if (inputText.length >= 3) {
			getCribLookupsTypeahead(groupId, inputText).then((response) => {
				callback(
					response.data.map((result: any) => {
						return {
							label: result.longValue,
							value: result.shortValue,
						};
					})
				);
			});
		}
	};

	return (
		<div key={`${n.type}${n.id}`} className={className ?? "crmls-field-wrap"}>
			<label htmlFor={n.id}>
				{n.label} {n.required && RequiredIndicator}
			</label>
			<div className="mt-1 sm:mt-0 sm:col-span-2">
				<div className="max-w-lg flex rounded-md shadow-sm">
					<AsyncSelect
						unstyled={true}
						id={n.id}
						name={n.id}
						isClearable={true}
						onBlur={handleBlur}
						onChange={onChange}
						placeholder={`Enter ${n.label}`}
						value={input}
						classNamePrefix="custom-input"
						className={inputClass}
						loadOptions={loadOptions}
					/>
				</div>
			</div>
			{touched[n.id] && errors[n.id] && (
				<div className="text-sm text-red-600">{errors[n.id]}</div>
			)}
		</div>
	);
};

export default LocationAutoComplete;
